import {
  Appointments,
} from '@devexpress/dx-react-scheduler-material-ui';
import { Grid } from '@mui/material';
import { classes, StyledAppointmentContent } from '../config';

const Appointment = ({
  data, children, style, ...restProps
}:any) => (
  <Appointments.Appointment
    {...restProps}
    style={{
      ...style,
      border: 'none',
      backgroundColor: data.color,
    }}
  >
    <StyledAppointmentContent className={classes.content}>
      <Grid container alignItems="flex-start" className={classes.titleContainer}>
        <Grid item xs={10}>
          <div>
            <div className={classes.title}>
              {data.title}
            </div>
          </div>
        </Grid>
      </Grid>
    </StyledAppointmentContent>
  </Appointments.Appointment>
);

export default Appointment;
